import axios from "axios";
import { getHeaders, checkStatus } from "../../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;
const tokenKey = process.env.REACT_APP_API_BASE_KEY;

export async function SendFeedback(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Feedback/Feedback/Save`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }


  export async function ShowFeedback(params) {
    try {
    const response = await axios.post(
      `${baseURL}/Feedback/Feedbacks`,params,
      {
        headers: {
          ...await getHeaders(),
          Authorization: `Bearer ${tokenKey}`,
        },
      }
    );
    checkStatus(response);
    return response.data;
  }catch(error){
      return Promise.reject(error);
    }
    
  }


  export async function DeleteFeedback(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}Feedback/Feedback/Delete`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }  
  }

  